<template>
  <div>
    <app-header><cp-nav></cp-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Lista Inscritos</h2>
      </div>
      <tabela-inscritos :lista="listaInscritos"></tabela-inscritos>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import CpNav from './Nav.vue'
import TabelaInscritos from '@/components/TabelaInscritos.vue'
import axios from 'axios'

export default {
  name: 'CpListaInscritos',
  components: {
    AppHeader,
    CpNav,
    TabelaInscritos
  },
  data () {
    return {
      listaInscritos: []
    }
  },
  mounted () {
    axios.get(process.env.WEB_API + 'getListaInscritos.php')
      .then(response => this.listaInscritos = response.data)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// ListaInscritos.vue?ac0e904a